module.exports = __webpack_public_path__ + "img/icon-9.7878c27c.png";